import { useEffect, useRef } from 'react';

import { useCart } from '../contexts/CartContext';

const COOLDOWN_MS = 6 * 60 * 60 * 1000;
const LAST_NOTIFY_KEY = 'pwa_cart_last_notify';
const ASK_PERMISSION_KEY = 'pwa_cart_ask_permission';

export default function PwaCartNotifier() {
  const { getItemCount } = useCart();
  const lastCount = useRef(0);

  useEffect(() => {
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    if (!standalone) return;

    const count = getItemCount();
    if (count <= 0 || count === lastCount.current) return;
    lastCount.current = count;

    const now = Date.now();
    const last = Number(localStorage.getItem(LAST_NOTIFY_KEY) || 0);
    if (now - last < COOLDOWN_MS) return;

    const maybeNotify = async () => {
      if (!('Notification' in window)) return;

      if (Notification.permission === 'default') {
        const asked = localStorage.getItem(ASK_PERMISSION_KEY) === '1';
        if (!asked) {
          localStorage.setItem(ASK_PERMISSION_KEY, '1');
          await Notification.requestPermission();
        }
      }

      if (Notification.permission !== 'granted') return;

      const registration = await navigator.serviceWorker?.getRegistration();
      if (!registration) return;

      registration.showNotification('Cart reminder', {
        body: `You have ${count} item${count > 1 ? 's' : ''} waiting in your cart.`,
        icon: '/icons/icon-192.png',
        badge: '/icons/icon-192.png',
        tag: 'cart-reminder',
      });

      localStorage.setItem(LAST_NOTIFY_KEY, String(now));
    };

    maybeNotify();
  }, [getItemCount]);

  return null;
}
